export const AD_BANNER_CLICK = (version = 'v1') => {
  return `${process.env.REACT_APP_SERVICE_TYPE}` === 'T'
    ? `https://link.dev.doctornow.co.kr/api/${version}/ads/click`
    : `https://link.doctornow.co.kr/api/${version}/ads/click`;
};
